"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AnimationGdpr = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Link = _interopRequireDefault(require("../Link"));
var _Text = _interopRequireDefault(require("../Text"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _constant = require("../JourneyPriceCTA/constant");
var _constant2 = require("../constant");
var _constant3 = require("./constant");
var _gdpr = _interopRequireDefault(require("./gdpr.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable react/destructuring-assignment */

var AnimationGdpr = (0, _styledComponents.keyframes)(["0%{min-height:0px;max-height:0px;opacity:0;top:-100px;}50%{min-height:50px;max-height:150px;height:auto;opacity:1;top:0px}75%{min-height:50px;max-height:150px;height:auto;opacity:1;top:4px}100%{min-height:50px;max-height:150px;height:auto;opacity:1;top:0px;}"]);
exports.AnimationGdpr = AnimationGdpr;
var GdprParentWrapper = _styledComponents.default.div.withConfig({
  displayName: "Gdpr__GdprParentWrapper",
  componentId: "sc-z30mcl-0"
})(["background:", ";display:inline-flex;flex:1;width:100%;min-height:50px;justify-content:center;position:relative;box-shadow:inset 0px -1px 0px 0px ", ";", " @media screen and (max-width:", "){position:fixed;bottom:0px;z-index:11;box-shadow:inset 0px 1px 0px 0px ", ";}"], function (props) {
  return props.theme.colors[props.background] || props.theme.backgroundColor.primary;
}, function (props) {
  return props.theme.colors.greyLight;
}, function (props) {
  return props.animation ? (0, _styledComponents.css)(["animation:", " 0.5s linear 1s 1 both;"], AnimationGdpr) : null;
}, _constant3.BREAKPOINTS.MOBILE, function (props) {
  return props.theme.colors.greyLight;
});
var GdprMainWrapper = _styledComponents.default.div.withConfig({
  displayName: "Gdpr__GdprMainWrapper",
  componentId: "sc-z30mcl-1"
})(["padding-right:25px;display:inline-flex;justify-content:center;align-content:center;width:93%;align-items:flex-start;padding:15px 0;position:relative;"]);
var GdprTextWrapper = _styledComponents.default.div.withConfig({
  displayName: "Gdpr__GdprTextWrapper",
  componentId: "sc-z30mcl-2"
})(["padding-right:5px;display:inline-block;position:relative;justify-content:center;align-content:center;margin-right:10px;"]);
var TextEdit = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "Gdpr__TextEdit",
  componentId: "sc-z30mcl-3"
})(["display:inline-block;"]);
var CloseButton = (0, _styledComponents.default)(function (_ref) {
  var handleClick = _ref.handleClick,
    icon = _ref.icon,
    tabIndex = _ref.tabIndex,
    iconColor = _ref.iconColor,
    className = _ref.className,
    idConfig = _ref.idConfig;
  var _ref2 = idConfig || {},
    widgetName = _ref2.widgetName,
    parentName = _ref2.parentName,
    index = _ref2.index;
  var _useState = (0, _react.useState)('closeButton'),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    dynamicID = _useState2[0],
    setId = _useState2[1];
  (0, _react.useEffect)(function () {
    var url = 'closeButton';
    if (parentName) {
      url = "".concat(parentName, "-closeButton");
    }
    if (index) {
      url += "-".concat(index);
    }
    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }
    setId(url);
  }, [widgetName, parentName, index]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: dynamicID,
    className: className,
    role: "button",
    tabIndex: tabIndex,
    onClick: function onClick() {
      return handleClick(true);
    },
    onKeyDown: function onKeyDown(e) {
      return _utilities.default.keyDownHandler(e, function () {
        return handleClick(true);
      }, _constant2.KEY_CODE.ENTER);
    },
    "aria-label": "Close button"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: icon,
    fontsize: _constant3.DEFAULT_STYLE.TITLE_NORMAL,
    color: iconColor,
    accessible: false
  }));
}).withConfig({
  displayName: "Gdpr__CloseButton",
  componentId: "sc-z30mcl-4"
})(["cursor:pointer;height:24px;width:24px;"]);
var Gdpr = function Gdpr(props) {
  var data = props.data,
    handleClick = props.handleClick,
    icon = props.icon,
    show = props.show,
    theme = props.theme,
    background = props.background,
    textColor = props.textColor,
    iconColor = props.iconColor,
    linkColor = props.linkColor,
    accessible = props.accessible,
    customProperties = props.customProperties,
    animation = props.animation;
  var content = data.content,
    link = data.link;
  var first = null;
  var second = null;
  var third = null;
  var tabIndex = !accessible ? '-1' : '0';
  if (content && link) {
    var arr = content.split('{0}');
    var _arr = (0, _slicedToArray2.default)(arr, 3);
    first = _arr[0];
    second = _arr[1];
    third = _arr[2];
  }
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var move = theme === _constant.THEMES.MOVE;
  var getMain = function getMain() {
    return show && content && link && /*#__PURE__*/_react.default.createElement(GdprParentWrapper, (0, _extends2.default)({
      theme: themeContext,
      background: background,
      animation: animation,
      tabIndex: tabIndex
    }, customProperties), /*#__PURE__*/_react.default.createElement(GdprMainWrapper, null, /*#__PURE__*/_react.default.createElement(GdprTextWrapper, null, /*#__PURE__*/_react.default.createElement(TextEdit, {
      type: _constant3.DEFAULT_STYLE.SUB,
      color: textColor
    }, first, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: link,
      size: _constant3.DEFAULT_STYLE.SMALL,
      color: move ? 'tertiaryRed' : linkColor,
      accessible: accessible,
      idConfig: {
        parentName: 'gdpr'
      }
    }, second), third || /*#__PURE__*/_react.default.createElement(_Text.default, null, third))), /*#__PURE__*/_react.default.createElement(CloseButton, {
      handleClick: handleClick,
      icon: icon,
      tabIndex: tabIndex,
      iconColor: iconColor,
      idConfig: {
        parentName: 'gdpr'
      }
    })));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Gdpr.propTypes = _gdpr.default.PropTypes;
Gdpr.defaultProps = _gdpr.default.DefaultProps;
var _default = Gdpr;
exports.default = _default;